(() => {
  if (customElements.get('mg-offer')) return;
  class MorganiteOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.config = JSON.parse(this.querySelector('[data-offer-config]').textContent);
      this.track = this.querySelector('.moffer-slides');
      this.frames = [...this.querySelectorAll('.moffer-slide')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.form = this.querySelector('form[action*="/cart/add"]');
      if (!this.form || !this.config.variants.length) return;
      this.variantInput = this.form.querySelector('[data-offer-variant]');
      this.planInput = this.form.querySelector('[data-offer-selling-plan]');
      this.planSelect = this.form.querySelector('[data-offer-plan-select]');
      this.variantSelect = this.form.querySelector('[data-offer-variant-select]');
      this.toggle = this.querySelector('[data-plan]');
      this.subscribed = !this.planInput.disabled;
      this.planId = String(this.planInput.value);
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: this.config.currency}).format(value / 100);
      this.addEventListener('click', event => {
        const b = event.target.closest('button');
        if (!b || !this.contains(b)) return;
        if (b.hasAttribute('data-thumb')) this.go(Number(b.dataset.thumb));
        if (b.hasAttribute('data-dir')) this.go(this.index() + Number(b.dataset.dir));
        if (b.hasAttribute('data-ingredients')) document.querySelector('.ming')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        if (b.hasAttribute('data-plan') && !b.disabled) { this.subscribed = !this.subscribed; this.update(); }
      }, {signal});
      this.addEventListener('change', event => {
        if (event.target === this.variantSelect) { this.variantInput.value = this.variantSelect.value; this.update(); }
        if (event.target === this.planSelect) { this.planId = this.planSelect.value; this.update(); }
      }, {signal});
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateGallery());
      }, {passive:true, signal});
      this.update(); this.updateGallery();
    }
    index() { const width = this.track.clientWidth; return width ? Math.round(this.track.scrollLeft / width) : 0; }
    go(index) { index = Math.max(0, Math.min(this.frames.length - 1, index)); this.track.scrollTo({left:index * this.track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); }
    updateGallery() { const i=this.index(); this.thumbs.forEach((b,j) => b.setAttribute('aria-pressed', String(i===j))); const prev=this.querySelector('[data-dir="-1"]'),next=this.querySelector('[data-dir="1"]'); if(prev)prev.disabled=i<=0;if(next)next.disabled=i>=this.frames.length-1; }
    update() {
      const v=this.config.variants.find(v=>String(v.id)===this.variantInput.value);
      if (!v) { this.form.querySelector('[type="submit"]').disabled=true; return; }
      const allocations=v.allocations;
      let allocation=allocations.find(a=>String(a.id)===this.planId) || allocations[0];
      if (this.config.requiresPlan) this.subscribed=true;
      if (!allocations.length) this.subscribed=false;
      this.planId=allocation ? String(allocation.id) : '';
      this.planInput.value=this.planId;
      this.planInput.disabled=!this.subscribed || !allocation;
      if(this.planSelect) {
        this.planSelect.replaceChildren(...allocations.map(a=>new Option(a.name,String(a.id),false,String(a.id)===this.planId)));
        this.querySelector('[data-plan-select-wrap]').hidden=!this.subscribed || allocations.length<2;
      }
      const price=this.subscribed && allocation ? allocation.price : v.price;
      const compare=Math.max(v.compare || 0,v.price);
      const saving=Math.max(0,compare-price);
      const percent=v.price && allocation ? Math.round((v.price-allocation.price)/v.price*100) : 0;
      this.querySelector('[data-price]').textContent=this.money(price);
      this.querySelector('[data-cta-price]').textContent=this.money(price);
      const crossed=this.querySelector('[data-compare-price]');crossed.textContent=this.money(compare);crossed.hidden=compare<=price;
      const badge=this.querySelector('[data-discount-badge]');if(badge){badge.hidden=!saving;badge.textContent=`Save ${compare ? Math.round(saving/compare*100) : 0}%`;}
      this.toggle.setAttribute('aria-checked',String(this.subscribed));
      this.toggle.disabled=this.config.requiresPlan || !allocations.length;
      this.querySelector('.moffer-plan').hidden=!allocations.length;
      this.querySelector('[data-plan-details]').hidden=!this.subscribed;
      const planName=this.querySelector('[data-plan-name]');planName.textContent=allocation?.name || '';planName.hidden=!this.subscribed;
      this.querySelector('[data-plan-heading]').textContent=percent>0 ? `Save ${percent}% with our flexible plan` : 'Subscribe with our flexible plan';
      const savingLabel=this.querySelector('[data-saving]'); if(savingLabel)savingLabel.textContent=this.money(saving);
      const savings=this.querySelector('.moffer-savings');if(savings)savings.hidden=!saving;
      const canBuy=v.available && (!this.config.requiresPlan || !!allocation);
      const submit=this.form.querySelector('[type="submit"]');submit.disabled=!canBuy;
      if(!submit.classList.contains('loading'))submit.removeAttribute('aria-disabled');
      this.querySelector('[data-add-label]').textContent=canBuy ? this.config.addLabel : 'Sold out';
    }
    disconnectedCallback() {cancelAnimationFrame(this.frame);cancelAnimationFrame(this.scrollFrame);this.abort?.abort();this.ready=false;}
  }
  customElements.define('mg-offer',MorganiteOffer);
})();
